import * as angular from 'angular';

import { ComponentDefinition, WidgetQualityResult } from '../../../models';
import { QualityPercentageWidget } from './qualityPercentage.widget';
import { GaugeOptions } from '../../../framework/charting/charts/Gauge/GaugeOptions';
import { GaugeDataFormat } from '../../../framework/charting/charts/Gauge/GaugeDataFormat';
import { computeError } from '../computeError';

class QualityPercentageController implements angular.IComponentController {
    data: GaugeDataFormat[];
    id: string;
    options: GaugeOptions;

    readonly boundData: { results: WidgetQualityResult };
    readonly item: QualityPercentageWidget;

    static $inject = [];

    $onInit() {
        this.id = `id${this.item.guid}`;
        this.setData();
        this.options = {
            isLegendVisible: false,
            isTitleVisible: false,
            labelsCount: 6,
            range: [-2 * Math.PI / 3, 2 * Math.PI / 3],
            thickness: .25,
            ticksCount: 6,
            tickSize: 5,
            title: '',
            showTarget: false
        };
        this.item.error = computeError(this.data[0].value, this.item.configuration.bands);
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['boundData'] && changesObj['boundData'].currentValue) {
            this.setData();
            this.item.error = computeError(this.data[0].value, this.item.configuration.bands);
        }
    }

    private setData() {
        this.data = [{
            bands: this.item.configuration.bands || [],
            format: '.0%',
            value: isNaN(this.boundData?.results?.percentage) ? 0 : this.boundData.results?.percentage
        }];
    }
}

export const wtQualityPercentage: ComponentDefinition = {
    componentId: 'wtQualityPercentage',
    controller: QualityPercentageController,
    template: require('./qualityPercentage.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '<',
        boundData: '<'
    }
};